import dayjs from 'dayjs'

import { type TaskActionHistoryItem } from '@/lib/queries/business/v1/task/action/history/types'
import { cn } from '@/lib/utils'

import { getDescriptionData, getIconData } from './utils'

export interface RecentActivitiesListProps {
  data?: TaskActionHistoryItem[]
}

export const RecentActivityList = ({ data }: RecentActivitiesListProps) => {
  if (!data || data.length === 0) {
    return <p className={cn('text-center text-gray-500', 'py-3')}>No data yet.</p>
  }

  return (
    <ol className={cn('relative', 'flex flex-col gap-y-[35px]')}>
      {data.length > 1 && <VerticalGrayLine />}
      {data.map(({ id, actionType, actionTitle, domain, createdAt, userName }, index) => (
        <li key={id} className={cn('relative')}>
          <WhiteMask isFirst={index === 0} isLast={index === data.length - 1} />
          <div className={cn('flex items-center gap-x-4')}>
            <img src={getIconData(actionType, domain)?.icon} alt={getIconData(actionType, domain)?.altText} />
            <div className={cn('flex flex-col gap-y-1')}>
              <p className={cn('text-xs font-normal text-slate-500')}>{dayjs.utc(createdAt).format('MM/DD/YYYY')}</p>
              <p className={cn('text-sm font-medium text-slate-900')}>{userName}</p>
              <p className={cn('text-xs font-normal text-slate-500')}>
                {getDescriptionData({ actionType, actionTitle, domain })}
              </p>
            </div>
          </div>
        </li>
      ))}
    </ol>
  )
}

const VerticalGrayLine = () => {
  return <div className={cn('absolute left-5 top-0', 'w-[1px]', 'h-full', 'bg-border')} />
}

const WhiteMask = ({ isFirst, isLast }: { isFirst: boolean; isLast: boolean }) => {
  return (
    <span
      className={cn(
        'hidden',
        {
          block: isFirst || isLast,
          'top-0': isFirst,
          'bottom-0': isLast,
        },
        'absolute left-5',
        'w-[1px]',
        'h-[calc(50%-20px)]',
        'bg-white'
      )}
    />
  )
}
